import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AdminProvider, useAdmin } from "./context/AdminContext";
import { Toaster } from "./components/ui/sonner";

// Public pages
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import History from "./components/History";
import HuntingArea from "./components/HuntingArea";
import Lodges from "./components/Lodges";
import News from "./components/News";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

// Admin pages
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LovskiTaborPage from "./pages/LovskiTaborPage";

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();

  if (loading) {
    return (
      <div className="min-h-screen bg-stone-900 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-emerald-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

// Public website component
const PublicSite = () => {
  return (
    <LanguageProvider>
      <div className="App bg-stone-900 min-h-screen">
        <Header />
        <main>
          <Hero />
          <About />
          <History />
          <HuntingArea />
          <Lodges />
          <News />
          <Contact />
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
};

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<PublicSite />} />
          <Route path="/lovski-tabor" element={<LovskiTaborPage />} />
          
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;
